import { userConstants, commonConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { beneficiaryEffect } from '../_effects';
import { commonEffect } from '../_effects';
import { alertActions } from './alertActions';

export const beneficiaryActions = {
  beneficiaryClient,
  addBeneficiary,
  getBankBranch,
  getRelationShip,
  getAllBanks,
  getAllBankBranches,
};

function beneficiaryClient(beneficiaryList) {
  return (dispatch) => {
    dispatch(request(beneficiaryList));
    beneficiaryEffect.getBeneficiaryDetails(beneficiaryList).then(
      (res) => {
        if (res.data.statusCode == 404 && res.data.message === 'Invalid Session ID') {
          alert('Session is not valid. Please login again');
          localStorage.clear();
          window.location = '/';
        }
        dispatch(success(res));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(beneficiaryList) {
    return { type: commonConstants.BENEFICAIRY_REQUEST, beneficiaryList };
  }
  function success(beneficiaryList) {
    return { type: commonConstants.BENEFICAIRY_SUCCESS, beneficiaryList };
  }
  function failure(error) {
    return { type: commonConstants.BENEFICAIRY_FAILURE, error };
  }
}
function addBeneficiary(addBeneficiary) {
  return (dispatch) => {
    dispatch(request(addBeneficiary));
    beneficiaryEffect.addBeneficiary(addBeneficiary).then(
      (addBeneficiary) => {
        dispatch(success(addBeneficiary));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(addBeneficiary) {
    return { type: commonConstants.ADD_BENEFICIARY_UAE_REQUEST, addBeneficiary };
  }
  function success(addBeneficiary) {
    return { type: commonConstants.ADD_BENEFICIARY_UAE_SUCCESS, addBeneficiary };
  }
  function failure(error) {
    return { type: commonConstants.ADD_BENEFICIARY_UAE_FAILURE, error };
  }
}

function getBankBranch(getbranch) {
  return (dispatch) => {
    dispatch(request(getbranch));
    beneficiaryEffect.getBankBranch(getbranch).then(
      (getbranch) => {
        dispatch(success(getbranch));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };
}

function request(getbranch) {
  return { type: commonConstants.BANK_BRANCH_REQUEST, getbranch };
}
function success(getbranch) {
  return { type: commonConstants.BANK_BRANCH_SUCCESS, getbranch };
}
function failure(error) {
  return { type: commonConstants.BANK_BRANCH_FAILURE, error };
}

function getAllBanks(payload) {
  return (dispatch) => {
    dispatch(requestAllBanks(payload));
    commonEffect.getOrganization(payload).then(
      (payload) => {
        dispatch(successAllBanks(payload));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failureAllBanks(error.toString()));
      }
    );
  };
}

function requestAllBanks(getbranch) {
  return { type: commonConstants.ALL_BANK_REQUEST, getbranch };
}
function successAllBanks(getbranch) {
  return { type: commonConstants.ALL_BANK_SUCCESS, getbranch };
}
function failureAllBanks(error) {
  return { type: commonConstants.ALL_BANK_FAILURE, error };
}

function getAllBankBranches(payload) {
  return (dispatch) => {
    dispatch(requestAllBankBranches(payload));
    commonEffect.getOrgBranch(payload).then(
      (payload) => {
        dispatch(successAllBankBranches(payload));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failureAllBankBranches(error.toString()));
      }
    );
  };
}

function requestAllBankBranches(getbranch) {
  return { type: commonConstants.ALL_BANK_BRANCH_REQUEST, getbranch };
}
function successAllBankBranches(getbranch) {
  return { type: commonConstants.ALL_BANK_BRANCH_SUCCESS, getbranch };
}
function failureAllBankBranches(error) {
  return { type: commonConstants.ALL_BANK_BRANCH_FAILURE, error };
}

function getRelationShip(getRelation) {
  return (dispatch) => {
    dispatch(request(getRelation));
    beneficiaryEffect.getRelationShip(getRelation).then(
      (getRelation) => {
        dispatch(success(getRelation));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(getRelation) {
    return { type: commonConstants.GET_RELATION_REQUEST, getRelation };
  }
  function success(getRelation) {
    return { type: commonConstants.GET_RELATION_SUCCESS, getRelation };
  }
  function failure(error) {
    return { type: commonConstants.GET_RELATION_FAILURE, error };
  }
}
